export const PURCHASE_ORDER_PROOF_STATUSES = [
  "Approved",
  "Rejected",
  "Pending Approval",
  "Proof Needed",
  "No Proof",
  "Proof Uploaded",
  "Requested",
  "Proof Complete",
];

const PURCHASE_ORDER_PROOF_STATUS_LABELS = {
  Requested: "Change Requested",
};

const LEGACY_PURCHASE_ORDER_PROOF_STATUSES = {
  "not required": "No Proof",
  uploaded: "Proof Uploaded",
};

const CANONICAL_STATUS_BY_KEY = PURCHASE_ORDER_PROOF_STATUSES.reduce(
  (statuses, status) => ({ ...statuses, [status.toLowerCase()]: status }),
  {}
);

export const normalizePurchaseOrderProofStatus = (
  proofStatus,
  fallback = "Proof Needed"
) => {
  const key = String(proofStatus || "").trim().toLowerCase();
  if (!key) return fallback;
  return LEGACY_PURCHASE_ORDER_PROOF_STATUSES[key]
    || CANONICAL_STATUS_BY_KEY[key]
    || fallback;
};

export const getPurchaseOrderProofStatusLabel = (proofStatus) => {
  const canonical = normalizePurchaseOrderProofStatus(proofStatus, proofStatus);
  return PURCHASE_ORDER_PROOF_STATUS_LABELS[canonical] || canonical;
};

export const PURCHASE_ORDER_PROOF_STATUS_OPTIONS = PURCHASE_ORDER_PROOF_STATUSES.map((status) => ({
  value: status,
  label: getPurchaseOrderProofStatusLabel(status),
}));

export const buildPurchaseOrderProofStatusPatch = (proofStatus) => ({
  proofStatus: normalizePurchaseOrderProofStatus(proofStatus),
});

export const getPurchaseOrderProofStatusForReadiness = (proofStatus, checked) => {
  const current = normalizePurchaseOrderProofStatus(proofStatus);
  if (["Approved", "Rejected", "Pending Approval", "Proof Complete"].includes(current)) {
    return current;
  }
  return checked ? "Proof Uploaded" : "Proof Needed";
};
